/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactComponent as MenuHide } from "../../menuhide.svg";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

const MenuHideButton = props => {
  return (
    <div
      onClick={props.onClick}
      css={css`
        position: absolute;
        top: 40%;
        right: -10px;
        width: 20px;
        height: 70px;
        cursor: pointer;
        display: ${props.visible ? "block" : "none"};
        > span {
          color: white;
          position: absolute;
          right: 0px;
          top: 35%;
          user-select: none;
          > svg {
            width: 15px;
            height: 20px;
          }
        }
        > svg > path {
          fill: #3b3b3b;
        }
        @media screen and (max-width: 480px) {
          transform: scale(1.7) rotate(270deg);
          top: -35px;
          right: -10px;
          width: 20px;
          height: 70px;
          left: calc(50%);
          > span {
            right: -2px;
          }
          > svg > path {
            fill: #262626;
          }
        }
      `}
    >
      <MenuHide />
      <span>
        <ArrowLeftIcon />
      </span>
    </div>
  );
};

export default MenuHideButton;
